'use strict';

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewIds = exports.INTERFACES = exports.Relations = exports.AudioManual = exports.Audio = exports.Blocks = exports.TextInput = exports.Review = exports.Choice = exports.Diff = exports.Compare = exports.Html = exports.ImageManual = exports.Image = exports.Dependencies = exports.SpansManual = exports.Spans = exports.Classification = exports.Text = undefined;

var _Choice = require('./Choice');

var _Choice2 = _interopRequireDefault(_Choice);

var _Classification = require('./Classification');

var _Classification2 = _interopRequireDefault(_Classification);

var _Compare = require('./Compare');

var _Compare2 = _interopRequireDefault(_Compare);

var _Dependencies = require('./Dependencies');

var _Dependencies2 = _interopRequireDefault(_Dependencies);

var _Diff = require('./Diff');

var _Diff2 = _interopRequireDefault(_Diff);

var _Spans = require('./Spans');

var _Spans2 = _interopRequireDefault(_Spans);

var _SpansManual = require('./SpansManual');

var _SpansManual2 = _interopRequireDefault(_SpansManual);

var _Html = require('./Html');

var _Html2 = _interopRequireDefault(_Html);

var _Image = require('./Image');

var _Image2 = _interopRequireDefault(_Image);

var _ImageManual = require('./ImageManual');

var _ImageManual2 = _interopRequireDefault(_ImageManual);

var _Text = require('./Text');

var _Text2 = _interopRequireDefault(_Text);

var _Review = require('./Review');

var _Review2 = _interopRequireDefault(_Review);

var _Input = require('./Input');

var _Input2 = _interopRequireDefault(_Input);

var _Blocks = require('./Blocks');

var _Blocks2 = _interopRequireDefault(_Blocks);

var _Audio = require('./Audio');

var _Relations = require('./Relations');

var _Relations2 = _interopRequireDefault(_Relations);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

exports.Text = _Text2["default"];
exports.Classification = _Classification2["default"];
exports.Spans = _Spans2["default"];
exports.SpansManual = _SpansManual2["default"];
exports.Dependencies = _Dependencies2["default"];
exports.Image = _Image2["default"];
exports.ImageManual = _ImageManual2["default"];
exports.Html = _Html2["default"];
exports.Compare = _Compare2["default"];
exports.Diff = _Diff2["default"];
exports.Choice = _Choice2["default"];
exports.Review = _Review2["default"];
exports.TextInput = _Input2["default"];
exports.Blocks = _Blocks2["default"];
exports.Audio = _Audio.Audio;
exports.AudioManual = _Audio.AudioManual;
exports.Relations = _Relations2["default"];
var INTERFACES = exports.INTERFACES = {
  text: _Text2["default"],
  classification: _Classification2["default"],
  spans: _Spans2["default"],
  spans_manual: _SpansManual2["default"],
  ner: _Spans2["default"],
  ner_manual: _SpansManual2["default"],
  pos: _Spans2["default"],
  pos_manual: _SpansManual2["default"],
  dep: _Dependencies2["default"],
  image: _Image2["default"],
  image_manual: _ImageManual2["default"],
  html: _Html2["default"],
  compare: _Compare2["default"],
  diff: _Diff2["default"],
  choice: _Choice2["default"],
  review: _Review2["default"],
  text_input: _Input2["default"],
  blocks: _Blocks2["default"],
  audio: _Audio.Audio,
  audio_manual: _Audio.AudioManual,
  relations: _Relations2["default"]
};
var viewIds = exports.viewIds = Object.keys(INTERFACES);